import type { TourStep } from '../types';

export const dcfAnalyzerSteps: TourStep[] = [
  {
    target: '[data-tour="tool-dcf"]',
    title: 'DCF Analyzer',
    content:
      'The DCF Analyzer builds a full Discounted Cash Flow model with year-by-year projections, tenant-level detail, and sensitivity analysis. Let\'s walk through it.',
    placement: 'bottom',
    route: '/appraisals/tools',
    nextButtonText: 'Open it',
  },
  {
    target: '[data-tour="dcf-header"]',
    title: 'Your DCF Workspace',
    content:
      'This standalone workspace auto-saves to your browser. You can build models here independently, or use the DCF within an appraisal report for the income approach.',
    placement: 'bottom',
    route: '/appraisals/tools/dcf',
  },
  {
    target: '[data-tour="dcf-property"]',
    title: 'Set Up the Property',
    content:
      'Start here: enter the Gross Leasable Area, select an analysis period (5–15 years), and set your discount and cap rates. Try entering a GLA value to get started.',
    placement: 'top',
    route: '/appraisals/tools/dcf',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve entered property info',
  },
  {
    target: '[data-tour="dcf-tabs"]',
    title: 'Work Through the Tabs',
    content:
      'The model flows left-to-right: Property → Rent Roll → Assumptions → Cash Flows → Results. Click the Rent Roll tab to add tenants.',
    placement: 'bottom',
    route: '/appraisals/tools/dcf',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve opened Rent Roll',
  },
  {
    target: '[data-tour="dcf-rentroll"]',
    title: 'Add a Tenant Lease',
    content:
      'Click the "+" button to add a tenant. Fill in the tenant name, suite, area (SF), rent per SF, and lease dates. You can add vacant spaces too — they\'ll be leased at market rates from your assumptions.',
    placement: 'top',
    route: '/appraisals/tools/dcf',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve added a lease',
  },
  {
    target: '[data-tour="dcf-calculate"]',
    title: 'Run the Calculation',
    content:
      'Once you\'ve entered property details and at least one lease, click Calculate to run the full DCF engine. It generates month-by-month cash flows and an indicated value.',
    placement: 'bottom',
    route: '/appraisals/tools/dcf',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve calculated',
  },
  {
    target: '[data-tour="dcf-results"]',
    title: 'Review Your Results',
    content:
      'The Results tab shows the indicated value, IRR, going-in yield, and a sensitivity matrix. You can also export the entire model to Excel with live formulas.',
    placement: 'top',
    route: '/appraisals/tools/dcf',
    spotlightClicks: true,
  },
];
